import Vue from 'vue'
import SvgSprite from 'vue-svg-sprite';

Vue.use(SvgSprite, { url: require('../assets/Icons/icons.svg')} )